/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AnyAutoTestStepAsJSON } from './AnyAutoTestStepAsJSON';
const AnyNonRedactedAutoTestStepAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['redacted', /* #__PURE__ */ parsers.exactly(false)],
]), AnyAutoTestStepAsJSON);
export class AnyNonRedactedAutoTestStepAsJSON extends AnyAutoTestStepAsJSON {
    static decode(input) {
        return AnyNonRedactedAutoTestStepAsJSONParser.decode(input).map(res => new AnyNonRedactedAutoTestStepAsJSON(res));
    }
    static unsafeDecode(input) {
        return AnyNonRedactedAutoTestStepAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AnyNonRedactedAutoTestStepAsJSONParser.encode(data);
    }
    static schema() {
        return AnyNonRedactedAutoTestStepAsJSONParser.schema();
    }
}
